/* eslint-disable no-unused-vars */

import React, { useEffect, useRef, useState } from "react";
import {
  Alert,
  Box,
  Button,
  Grid,
  Paper,
  Table,
  tbody,
  td,
  TableContainer,
  th,
  tr,
} from "@mui/material";
import FormTitle from "../../../form-fields/form-title";
import DashBoardContainer from "../../../layout/dashboard-container";
import {
  FormLabel,
  FormValue,
  GridRow,
} from "../generate-receipt/custom-form-grid";
import { useSelector } from "react-redux";
import { labels } from "../../../../lang/labels";
import "./style.css";
import { useReactToPrint } from "react-to-print";
import { ArrowBack, Print } from "@mui/icons-material";
import { useLocation, useNavigate } from "react-router-dom";
import { getPrintReceiptDetails } from "../../../../services/generate-counter-receipt";
import { errorMsg } from "../../../../utils/constants";
import Loader from "../../../loader/loader";
import AlertMsg from "../../../common/alert";
import { formatDateTime, getErrorMsg } from "../../../../utils/helpers";
import { showToastError } from "../../../common/toastHelper";

const PrintReceipt = () => {
  const navigate = useNavigate();
  const query = new URLSearchParams(useLocation().search);
  const receiptNo = query.get("receiptNo");
  const receiptType = query.get("receiptType");
  const [receiptPrintData, setReceiptPrintData] = useState("");
  const printRef = useRef();
  const lang = useSelector((state) => state.userDetails.lang);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  useEffect(() => {
    const getData = async () => {
      try {
        setError("");
        setLoading(true);
        const response = await getPrintReceiptDetails(receiptNo, receiptType);
        setReceiptPrintData(response);
      } catch (error) {
        showToastError(getErrorMsg(error));
      } finally {
        setLoading(false);
      }
    };

    getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const handlePrint = useReactToPrint({
    content: () => printRef.current,
  });
  return (
    <DashBoardContainer>
      {loading && <Loader message="Loading receipt details..." />}
      {error && (
        <AlertMsg
          severity="error"
          onClose={() => {
            setError("");
          }}
        />
      )}
      {receiptNo && receiptType && receiptPrintData && (
        <Paper elevation={4} sx={{ marginBottom: "15px" }}>
          <FormTitle title={labels.PropertLevyReceipt[lang]} />
          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
            <Button
              sx={{ margin: 2 }}
              onClick={handlePrint}
              variant="contained"
              startIcon={<Print />}
            >
              Print
            </Button>
            <Button
              sx={{ margin: 2 }}
              onClick={() => {
                navigate(-1);
              }}
              variant="contained"
              startIcon={<ArrowBack />}
            >
              Back
            </Button>
          </Box>

          <Grid ref={printRef}>
            <Box
              sx={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
                marginTop: "90px",
              }}
            >
              <Grid
                container
                spacing={1}
                rowSpacing={0.6}
                sx={{
                  width: "60%",
                  fontSize: "12px",
                }}
              >
                <Grid item xs={3}>
                  {labels.Date[lang]}:
                </Grid>
                <Grid item xs={3}>
                  {receiptPrintData.receiptdate}
                </Grid>
                <Grid item xs={3}>
                  {labels.ReceiptNumber[lang]}:
                </Grid>
                <Grid item xs={3}>
                  {receiptPrintData.receiptno}
                </Grid>

                <Grid item xs={3}>
                  {labels.PropertyNumber[lang]}:
                </Grid>
                <Grid item xs={3}>
                  {receiptPrintData.propertycode}
                </Grid>
                <Grid item xs={3}>
                  {labels.ZoneReceiptNumber[lang]}:
                </Grid>
                <Grid item xs={3}>
                  {receiptPrintData.zoneReceiptNo}
                </Grid>

                <Grid item xs={3}>
                  {labels.MalakName[lang]}:
                </Grid>
                <Grid item xs={9}>
                  {receiptPrintData.ownername}
                </Grid>
                <Grid item xs={3}>
                  {labels.occupantName[lang]}:
                </Grid>
                <Grid item xs={9}>
                  {receiptPrintData.occupantname}
                </Grid>
                <Grid item xs={3}>
                  {labels.Address[lang]}:
                </Grid>
                <Grid item xs={9}>
                  {receiptPrintData.address}
                </Grid>

                <Grid item xs={3}>
                  {labels.Placeofpayment[lang]}:
                </Grid>
                <Grid item xs={3}>
                  {receiptPrintData.zonename}
                </Grid>
                <Grid item xs={3}>
                  {labels.Year[lang]}:
                </Grid>
                <Grid item xs={3}>
                  {receiptPrintData.finYear}
                </Grid>

                <Grid item xs={3}>
                  {labels.receivedPaymentMode[lang]}:
                </Grid>
                <Grid item xs={9}>
                  {receiptPrintData.modeofpayment}
                </Grid>

                <Grid item xs={5}>
                  {labels.AmtInWordNote[lang]}:
                </Grid>
                <Grid item xs={7}>
                  {receiptPrintData.rupees_inMarathi}
                </Grid>
                <Grid item xs={12}>
                  {receiptPrintData.lstReceiptPrintHeadwiseRO &&
                    receiptPrintData.lstReceiptPrintHeadwiseRO.length && (
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "center",
                        }}
                      >
                        {/* <TableContainer component={Paper}> */}
                        <table
                          // sx={{ minWidth: 650 }}
                          // aria-label="simple table"
                          style={{
                            "min-width": "550px",
                            "border-collapse": "collapse",
                            width: "75%",
                            border: "1px solid black",
                          }}
                        >
                          <thead>
                            <tr
                              sx={{
                                background: "#e6eaeb",
                                "&:last-child td, &:last-child th": {
                                  border: "1px solid black",
                                },
                                fontSize: "14px", // Custom font size
                                height: "35px", // Custom row height
                                padding: "0px",
                                "text-align": "center",
                              }}
                            >
                              <th align="center" className="cellBorder">
                                {labels.TaxName[lang]}
                              </th>
                              <th align="center" className="cellBorder">
                                {labels.Pre[lang]}
                              </th>
                              <th align="center" className="cellBorder">
                                {labels.Curr[lang]}
                              </th>
                              <th align="center" className="cellBorder">
                                {labels.Total[lang]}
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {receiptPrintData.lstReceiptPrintHeadwiseRO.map(
                              (item, index) => {
                                return (
                                  <tr key={index}>
                                    <td
                                      align="left"
                                      className="cellBorder"
                                      sx={{
                                        fontSize: "14px", // Custom font size
                                        height: "20px", // Custom row height
                                      }}
                                    >
                                      {item.taxName}
                                    </td>
                                    <td align="right" className="cellBorder">
                                      {item.previou}
                                    </td>
                                    <td align="right" className="cellBorder">
                                      {item.current}
                                    </td>
                                    <td align="right" className="cellBorder">
                                      {item.total}
                                    </td>
                                  </tr>
                                );
                              }
                            )}
                          </tbody>
                          <thead>
                            <tr
                              sx={{
                                background: "#e6eaeb",
                                "&:last-child td, &:last-child th": {
                                  border: "1px solid black",
                                },
                                fontSize: "14px", // Custom font size
                                height: "20px", // Custom row height
                              }}
                            >
                              <th align="center" className="cellBorder">
                                {labels.Total[lang]}
                              </th>
                              <th align="right" className="cellBorder">
                                {receiptPrintData.prevTotal}
                              </th>
                              <th align="right" className="cellBorder">
                                {receiptPrintData.currTotal}
                              </th>
                              <th align="right" className="cellBorder">
                                {receiptPrintData.totalPaid}
                              </th>
                            </tr>
                          </thead>
                        </table>
                        {/* </TableContainer> */}
                      </Box>
                    )}
                </Grid>
                <Grid item xs={3}>
                  {labels.ExtraPaidAmount[lang]}:
                </Grid>
                <Grid item xs={9}>
                  {receiptPrintData.fajilAmount}
                </Grid>

                <Grid item xs={3}>
                  {labels.ChequeDDNumber[lang]}:
                </Grid>
                <Grid item xs={3}>
                  {receiptPrintData.chequeDDNo}
                </Grid>
                <Grid item xs={3}>
                  {labels.ChequeDDDate[lang]}:
                </Grid>
                <Grid item xs={3}>
                  {receiptPrintData.chequeDDDate}
                </Grid>

                <Grid item xs={3}>
                  {labels.BankName[lang]}:
                </Grid>
                <Grid item xs={9}>
                  {receiptPrintData.bankName}
                </Grid>

                <Grid item xs={3}>
                  {labels.UserName[lang]}:
                </Grid>
                <Grid item xs={3}>
                  {receiptPrintData.userName}
                </Grid>

                <Grid item xs={3}>
                  {formatDateTime()}
                </Grid>

                <Grid item xs={4}>
                  {labels.Remark[lang]}:
                </Grid>
                <Grid item xs={8}>
                  {receiptPrintData.remark || ""}
                </Grid>

                <Grid
                  item
                  xs={12}
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <h3 style={{ margin: "0px" }}>{labels.voterLabel[lang]}</h3>
                </Grid>
                <Grid
                  item
                  xs={12}
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <b> Website: voters.ecl.gov.in</b>
                </Grid>
              </Grid>
            </Box>
          </Grid>
        </Paper>
      )}
    </DashBoardContainer>
  );
};

export default PrintReceipt;
